module.exports = __webpack_public_path__ + "static/media/headerImage1.6105f9af.jpg";